export default "__VITE_ASSET__DUULAEUD__"